import React from 'react';
import PropTypes from 'prop-types';
import { SparkIcon, TooltipTrigger, TruncatedText } from '@spark';

/**
 * Figma field label: 14px medium text, optional red required asterisk, and an
 * optional 16px help-circle icon with a hover tooltip. `truncate` keeps the
 * name on one line with ellipsis and shows the full value on hover.
 */
const FieldLabel = ({ text, required = false, help, htmlFor, truncate = false }) => (
    <label
        className={truncate ? 'gdai-field-label gdai-field-label--truncate' : 'gdai-field-label'}
        htmlFor={htmlFor}
    >
        {truncate ? (
            <TruncatedText
                text={text}
                maxWidth="100%"
                alwaysShowTooltip
                className="fs-unmask"
            />
        ) : (
            <span className="fs-unmask">{text}</span>
        )}
        {required ? (
            <span className="gdai-field-label__asterisk" aria-hidden="true">
                *
            </span>
        ) : null}
        {help ? (
            <TooltipTrigger text={help}>
                <span className="gdai-field-label__help">
                    <SparkIcon slug="circle-help" size="small" />
                </span>
            </TooltipTrigger>
        ) : null}
    </label>
);

FieldLabel.propTypes = {
    text: PropTypes.string.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    htmlFor: PropTypes.string,
    truncate: PropTypes.bool,
};

export default FieldLabel;
